<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <span v-show="error" class="help is-danger">{{error}}</span>

      <div class="lps header-bar fixed" style="top: 64px; padding-top: 25px;"> 
        <h2>
          <div class="lp-toc-button" title="Toggle Table of Contents" v-on:click="toggleLPTOC()">
            <i class="fal fa-bars"></i>
          </div> 
          {{group.name}}
        </h2>
        <div class='right-tools no-select'>
          <DueDateFilter 
            :dateFilterApplied="filtersApplied"  
            :popupOptions="dateFilterPopupOptions"
          />
          <!-- <i class="fal fa-calendar"></i>
          <i class="fal fa-tag"></i> -->
          <TagsFilter 
            :tags="lpData.tags" 
            :tagFiltersApplied="filtersApplied"  
            :popupOptions="tagsFilterPopupOptions"
          />
          <ResourceTypesFilter 
            :resourceTypes="resourceTypes" 
            :resourceTypeFiltersApplied="filtersApplied"  
            :popupOptions="resourceTypesFilterPopupOptions"
          />
        </div>
        <div class="search">
          <div class="tr">
            <div class="search-icon">
              <span class="fal fa-search fa-lg"></span>
            </div>
            <div class="td">
              <span class="search-input">
                <input type="text" name="search" v-on:input="lpSearchChanged()" v-model="lpSearch" placeholder="Search" autocomplete="off"/>
                <div v-if="lpSearch" v-on:click="lpSearch = ''; lpSearchChanged()" class="clear-button">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </div>
              </span>
            </div>
            <div class="search-count-td">
              <span class="search-count" v-if="lpCurrentSearchCount > 0 && lpSearch.length > 0">
              <span v-if="lpCurrentSearchCount > 0">{{lpCurrentSearchIndex}} / {{lpCurrentSearchCount}}</span>
              <span class="search-nav no-select">
                <span class="fal fa-chevron-left fa-lg" @click="lpNavSearchResult(false)"></span>
                <span class="fal fa-chevron-right fa-lg" @click="lpNavSearchResult(true)"></span>
              </span>
            </span>
            <span class="search-count" v-else-if="lpCurrentSearchCount === 0 && lpSearch.length > 0">No results</span>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-top: 115px">
        <learning-path v-show="!loading"></learning-path>
      </div>
    </div>
    
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');

  require('./itsi-lp-bridge.js');

  import ResourceTypesFilter from '@/components/widgets/filters/ResourceTypesFilter';
  import TagsFilter from '@/components/widgets/filters/TagsFilter';
  import DueDateFilter from '@/components/widgets/filters/DueDateFilter';
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import analytics from '@/utils/analytics.js';

  export default {
    name: 'GroupDashboard',
    components: { 
      ResourceTypesFilter,
      TagsFilter,
      DueDateFilter
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       group: {},
       lpData: {},
       moment: moment,
       utils: utils,
       error: '',
       resourceTypes: {},
       lpSearch: '',
       resourceTypesFilterPopupOptions: {active: false},
       tagsFilterPopupOptions: {active: false},
       dateFilterPopupOptions: {active: false, fromDate: -1, toDate: -1, type: 'All dates'},
       lpCurrentSearchCount: 0,
       lpCurrentSearchIndex: 0,
       unwatchFunctions: []
      }
    },
    destroyed: function() {
      _.each(this.unwatchFunctions, function(unwatchFunction) {
        unwatchFunction();
      });
    },
    created: function () {
      this.itsiLPBridge();
    },
    mounted: function () {
      this.resourceTypes = utils.getAllResourceTypes(['flashcarddeck', 'note', 'sketch', 'googledrive', 'drawing']);
      _.each(this.resourceTypes, function(type) {
        Vue.set(type, 'filteredIn', true);  
      });

      storeHelpers.checkActive(this);
      
      this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ['groups', 'resources', 'attachments', 'learningPaths', 'userState'], this.lpUpdated);

      // learningPathViewToggle: function(handle, fullScreen)
      analytics.learningPathViewToggle(this, true);
    },
    methods: {
      resetAllFilters: function () {
        _.each(this.resourceTypes, function(type) {
          Vue.set(type, 'filteredIn', true);  
        });

        _.each(this.lpData.tags, function(tag) {
          Vue.set(tag, 'filteredIn', true);  
        });

        Vue.set(this.dateFilterPopupOptions, 'fromDate', -1);
        Vue.set(this.dateFilterPopupOptions, 'toDate', -1);
        Vue.set(this.dateFilterPopupOptions, 'type', 'All dates');

        this.filtersApplied();
      },
      filtersApplied: function () {
        // resources
        var filteredInResources = _.filter(this.resourceTypes, function(type) { return type.filteredIn})
        var filteredInResourcesMapped = _.flatMap(filteredInResources, function(resourceType) { return resourceType.type; });
        var filteredInResourcesString = filteredInResources.length === Object.keys(this.resourceTypes).length ? 'all' : filteredInResourcesMapped

        // tags
        var filteredInTags = _.filter(this.lpData.tags, function(tag) { return tag.filteredIn})
        var filteredInTagsMapped = _.flatMap(filteredInTags, function(tag) { return tag.tag_id; });
        var filteredInTagsString = filteredInTags.length === Object.keys(this.lpData.tags).length ? 'all' : "[" + filteredInTagsMapped.join(", ") + "]";
        
        window.lp.filter(filteredInTagsString, filteredInResourcesString, this.dateFilterPopupOptions.fromDate, this.dateFilterPopupOptions.toDate)
        if (filteredInResourcesString !== "all" || filteredInTagsString !== "all") {
          this.filterDebounce(filteredInTagsString, filteredInResourcesString, this.dateFilterPopupOptions.fromDate, this.dateFilterPopupOptions.toDate);
        }
      },
      filterDebounce: _.debounce(function(tags, resources, startdate, enddate) {
        analytics.filterLearningPath(this, this.group._id, tags, resources, startdate, enddate);
      }, 1000),
      lpSearchChanged: _.debounce(function() {
        window.lp.search(this.lpSearch, true);
        if (this.lpSearch) {
            // searchLearningPath: function(handle, learningPathId, searchTerm, numberOfResults, location = 0)
            // still need:
            //      location:
            //           NOT_SET = 0;
            //           GROUP_SELECTION = 1;
            //           LEARNING_PATH = 2;
            //           LEARNING_PATH_DASHBOARD = 3;
            analytics.searchLearningPath(this, this.group._id, this.lpSearch, this.lpCurrentSearchCount, 2);
        }
      }, 800),
      lpNavSearchResult: function(next) {
        window.lp.navSearchResult(next);
      },
      toggleLPTOC: function() {
        window.lp.toggleNav();
      },
      lpUpdated: function (property, value) {
        var t = this;

        var group = _.find(t.$store.state.groups, function(group) {
          return group._id === t.$route.params.id;
        })

        if(!group) return;

        t.loading = false;

        // filtered in cache
        var oldTags = {};
        if(property !== 'init' && t.lpData.tags) {
          oldTags = _.keyBy(JSON.parse(JSON.stringify(t.lpData.tags)), 'tag_id');
        }

        t.group = group;
        t.lpData = storeHelpers.getLPData(this, group._id)

        // apply filtered in cache
        _.each(this.lpData.tags, function(tag) {
          Vue.set(tag, 'filteredIn', oldTags[tag.tag_id] ? oldTags[tag.tag_id].filteredIn : true);  
        });

        const pagesOpened = storeHelpers.getPagesOpened(this, group.code);

        window.lp.renderPath(t.lpData.lpItems, t.lpData.resources, t.lpData.attachments, t.lpData.userState, t.lpData.tags, pagesOpened, 'web', false, '')   
        this.filtersApplied();

        setTimeout(function() {
          t.loading = false;
          window.lp.resizeLPItems();
        }, 500)
      },
      itsiLPBridge: function() {
        var t = this;
        window.ITSIBridge = {
          disableScroll: true,
          lpTopVisibleElementChanged: function (lpItemId) {
            utils.log(t, 'Top visible changed ' + lpItemId);
          },
          resourceLPItemClicked: function (lpItemId, attachmentId, resourceId, isTask) {
            utils.log(t, 'LP Item clicked: ' + lpItemId + ' attachmentId: ' + attachmentId + ' resourceId: ' + resourceId);
            utils.openResourceById(t, resourceId, [attachmentId])
          },
          lpPageRangeClicked: function(lpItemId, book, pageFrom, pageTo) {   
            utils.log(t, 'lpPageRangeClicked: ' + lpItemId + ' book: ' + book + ' pageFrom: ' + pageFrom + ' pageTo: ' + pageTo);
            t.$router.push("/book/" + book + "/" + pageFrom);
          },
          lpItemToggle: function (lpItemId, expanded) {
            utils.log(t, 'LP Item toggled: ' + lpItemId + ', expanded: ' + expanded);
          },
          lpSearchFinished: function (currentSearchIndex, numberOfResults) {
            utils.log(t, 'LP search results for ' + window.platform + ': ' + currentSearchIndex + ' of ' +numberOfResults);

            t.lpCurrentSearchCount = numberOfResults;
            t.lpCurrentSearchIndex = currentSearchIndex;
          },
          lpSearchCleared: function () {
            t.lpCurrentSearchCount = 0;
            t.lpCurrentSearchIndex = 0;
          },
          navToLPItem: function (lpItemId, isVisible) {
            utils.log(t, 'LP nav from TOC: ' + lpItemId + ' (visible: ' + isVisible + ')');
          },
          resetLPFilters: function () {
            utils.log(t, 'Reset all LP filters');
            t.resetAllFilters();
          },
          lpTagClicked: function (tag, active) {
            utils.log(t, 'LP tag: ' + tag + ' (active: ' + active + ')');
          },
          gotoLocation: function (attachment) {
            utils.log(t, 'Go to location: Attachment: ' + attachment._id + ' book: ' + attachment.book + ' section: ' + attachment.section + ' selector: ' + attachment.selector);
          },
          parseJSONifString: function (possibleString) {
            return possibleString;
          },
          pageLoaded: function () {
          },
          smileyMagic: function (string) {
            // same across platforms
            return decodeURIComponent(escape(string));
          }
        };
      }
    }
  }

  
</script>

<style>
.learning-path {
  position: relative;
  overflow-x: hidden;
  min-height: 300px;
}

.learning-path .main {
  margin-top: 10px;
}

.learning-path .overlay {
  height: 300px;
  background: #fafafa;
}

.learning-path .loading {
    display: none;
}

.learning-path .overlay .center-box {
  font-size: 12pt;
  margin-top: 10px;
  height: 200px;
}

.learning-path .overlay button {
  background: #2f67b1;
  color: white !important;
  border: 0;
  padding: 10px;
  font-size: 12pt;
  margin-top: 10px;
}

.learning-path .toc-container {
  height: calc(100vh - 218px);
  overflow-y: auto;
  padding-bottom: 100px;
}

.learning-path .sidenav {
  text-align: left;
  position: fixed;
  z-index: 0;
  top: 177px !important;
  padding-top: 0px !important;
}

.learning-path .sidenav .title {
  font-size: 12pt;
}

.learning-path .sidenav ul ul {
  margin-top: 0;
}

@media screen and (min-width: 1280px) {
  .learning-path .container {
    max-width: none !important;
    width: auto !important;
  }
}

@media screen and (min-width: 1088px) {
  .learning-path .container {
    max-width: none !important;
    width: auto !important;
  }
}

</style>

<style scoped lang="scss">
@import "src/css/vars.scss";

.content {
  max-width: none;
  padding: 0;
}

.lp-toc-button {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.lp-toc-button .fal {
  font-size: 14pt;
}

.search {
  display: table;
  margin-bottom: 0;
  width: 100%;

  .tr {
    display: table-row;
    width: 100%;

    .search-icon {
      display: table-cell;
      width: 3.5%;
    }

    .td {
      width: 100%;
      display: table-cell;
    }

    .search-count-td {
      width: 150px;
      padding-left: 2px;
    }

    .search-count-td .search-nav {
      margin-left: auto;
      margin-right: auto;
    }

    .search-count-td .search-nav > span {
      padding-left: 10px;
      cursor: pointer;
      color: $primary-color;
    }

    .search-count-td .search-nav > span:hover {
      color: #aaa;
    }
  }
}

.learning-path {
  margin-top: -10px;
  max-width: 100%;
}

.group {
  text-align: left;
  border-bottom: 1px solid #eee;
  height: 70px;
}

.group:hover {
  background: #eee;
  cursor: pointer;
}

.group span {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-top: 22px;
}

.group-color {
  width: 10px;
  height: 100%;
  background: black;
  display: inline-block;
}

.content {
  padding-bottom: 30px;
}
</style>